module.exports = __webpack_public_path__ + "img/user_lose_top3.2ea07e22.png";